__webpack_require__.p = "/issues/40/marm-the-doctor-mill-children-and-the-american-dream-in-one-way-to-get-an-education/";